import { Divider, Grid } from "@mui/material";
import React from "react";
import DetailsSection from "./DetailsSection";
import GeneralBillingSection from "./GeneralBillingSection";
import PackagesSection from "./PackagesSection";
import useStyles from "./SiteSetup.style";

const SiteSetupFields = () => {
  const classes: any = useStyles();

  return (
    <Grid container columnSpacing={2}>
      {/* Details and General + Billing side by side on wide screens, stacked on narrow ones */}
      <Grid item xs={12}>
        <div className={classes.columns}>
          <div className={classes.column}>
            <DetailsSection />
          </div>
          <Divider orientation="vertical" flexItem className={classes.columnDivider} />
          <div className={classes.column}>
            <GeneralBillingSection />
          </div>
        </div>
      </Grid>
      <PackagesSection />
    </Grid>
  );
};

export default SiteSetupFields;
